<template>
    <div>
        <div class="numeroCall">
            <div>
                Par SMS, envoyer <b class="conditions">CODE au 81072</b> et recevez votre code
            </div>
            <div>
                ou appelez le <a href="tel:0890165474 ">08 90 16 54 74</a> pour obtenir votre code
            </div>
            
        </div>
        <div class="conditions">
            Ce service vous coutera 2€ par sms (ou par appel) + prix du sms ou de l'appel selon votre opérateur</br>
        </div>
         <div class="conditions">
            Une fois le code saisi, cliquez sur valider le code et vous serez crédité d'1 concours !
        </div>
        <div class="conditions">
           Ce code n'est valable qu'une fois
        </div>
        <br/>
        <div class="labelCode">
        <s-input theme="is-large is-primary" width="200px" v-model="code" placeholder="Saisir le code"/>
        </div>
        <div class="buttonValide">
            <s-button label="Valider le code" @onclick="payment" :theme="!loading ? 'is-success is-large' : 'is-warnng is-loading is-large'" />
       </div>
        <div class="conditionsMobyo">
            Ce service est délivré par <a href="https://www.mobiyo.com/">mobiyo</a>
            
        </div>
        <s-modal 
            :open="creditOk"
        >
            <div class="felicitation">
                Félicitation : vous avez été crédité d'1 concours !!!
                <div>
                    <s-button icon="smile-wink" @onclick="close" label="J'ai compris !!!" theme="is-large is-success"/>
                </div>
            </div>
        </s-modal>
        <s-modal 
            :open="creditKo"
        >
            <div class="creditKo">
                Nous sommes navré, il y a eu un problème
                Soit le code est expiré ou n'est pas connu... <br/>
                Ou le code a déjà été utilisé.
               
                <div>
                    <s-button @onclick="creditKo=false" label="J'ai compris" theme="is-primary"/>
                </div>
             </div>
        </s-modal>
    </div>
</template>
<style scoped>
    .numeroCall {
        text-align: center;
        font-size: 22px;
        color: black;
        font-weight: bolder;
    }
    .conditions {
        text-align: center;
        color: rgb(185, 8, 8);
        font-size: 20px;
    }
    .labelCode {
        text-align: center;
    }
    .buttonValide {
         text-align: center;
         margin-top: 20px;
    }
    .conditionsMobyo {
        margin-top: 20px;
        font-size: 16px;
        color: black;
       
    }
    .felicitation {
        color: rgb(32, 136, 32);
        font-weight: bolder;
        font-size: 30px;
    }
    .felicitation div {
        margin-top: 20px;
        text-align: center;
    }
    .creditKo  {
        color: rgb(168, 27, 27);
        font-weight: bolder;
        font-size: 30px;
    }
    .creditKo div {
        margin-top: 20px;
        text-align: center;
    }
</style>
<script>
import firebase from "firebase"
export default {
    data() {
        return {
            loading : false,
            code : "",
            creditOk: false,
            creditKo: false
        }
    },
    methods: {
        payment() {
            this.loading  = true;
            const functions = firebase.app().functions('europe-west1');
            const params =  {
                code: this.code
            }
            this.openWaiting = true;
            functions.httpsCallable("addCreditByAllopass")(params).then(res=>{
               this.loading  = false;
               
               if (res.data.success)
                    this.creditOk = true;
               else
                    this.creditKo = true; 
                // on envoie le mail
                // on dit un message comme quoi c bon
                // il peut aller les voir dans l'historique
                // i lpeut les anneuler tant que ca n'a pas été pris
            })
        },
        close() {
            this.creditOk = false;
            this.creditKo = false;
            this.code = "";
            this.$emit("close");
        }
    },
    
}
</script>